import React, { useState } from 'react';
import { NavLink, Redirect, Route, useLocation } from 'react-router-dom';
import { Invoices, PricingCalculator, Remittance, WalletTransaction } from '../..';
import { LabeledInput } from '../../../Components';
import { useUser } from '../../../Context/User';
import { MerchantProtectedRoutes } from '../../../Routes/Index';

import './style.css';
const Index = () => {
    const path = useLocation();
    const { role } = useUser();
    const [id, setID] = useState('');
    return (
        <div className="billing">
            <div style={{ flexWrap: 'wrap' }} className="billing_head">
                <h2>
                    Billing -{' '}
                    {path.pathname.endsWith('priceCalculator')
                        ? 'Price Calculator'
                        : path.pathname.endsWith('codRemittance')
                        ? ' COD Remittance'
                        : path.pathname.endsWith('walletTransaction')
                        ? ' Wallet Transaction'
                        : 'Invoice'}
                </h2>
                {role === 'admin' && (
                    <div className="user_search_billing">
                        <div className="user_search_billing_saerch">
                            <LabeledInput
                                name="merchant id"
                                value={id}
                                changeHandler={(e) => {
                                    setID(e.target.value);
                                }}
                                label={'Merchant ID'}
                            />
                        </div>
                        <div className="user_search_billing_buttons">
                            <button style={{ marginRight: '1rem' }} type="submit" className="btn-orange">
                                <p>Apply</p>
                            </button>
                            <button type="reset" className="btn-gray">
                                <p>Clear</p>
                            </button>
                        </div>
                    </div>
                )}
            </div>
            <nav className="billing_navigation">
                {role === 'merchant' && (
                    <NavLink
                        className="billing_navigation_item"
                        activeClassName="active"
                        to="/main/billing/priceCalculator"
                    >
                        Price Calculator
                    </NavLink>
                )}
                <NavLink className="billing_navigation_item" activeClassName="active" to="/main/billing/codRemittance">
                    COD Remittance
                </NavLink>
                <NavLink
                    className="billing_navigation_item"
                    activeClassName="active"
                    to="/main/billing/walletTransaction"
                >
                    Wallet Transaction
                </NavLink>
                <NavLink className="billing_navigation_item" activeClassName="active" to="/main/billing/invoice">
                    Invoice
                </NavLink>
            </nav>
            <div className="billing_content">
                <MerchantProtectedRoutes
                    fallback="/main/billing/codRemittance"
                    path="/main/billing/priceCalculator"
                    exact
                >
                    <PricingCalculator />
                </MerchantProtectedRoutes>
                <Route path="/main/billing/walletTransaction" exact>
                    <WalletTransaction />
                </Route>
                <Route path="/main/billing/codRemittance" exact>
                    <Remittance />
                </Route>

                <Route path="/main/billing/invoice" exact>
                    <Invoices />
                </Route>
                <Redirect to="/main/billing/priceCalculator" />
            </div>
        </div>
    );
};

export default Index;
